import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import API from "../../api/api";
import { getUserId } from "../../utils/auth";

const ChangePassword = () => {
    const [formData, setFormData] = useState({
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""
    });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (formData.newPassword !== formData.confirmPassword) {
            toast.error("New passwords do not match!");
            return;
        }

        if (formData.newPassword.length < 6) {
            toast.error("Password must be at least 6 characters long.");
            return;
        }

        setLoading(true);
        console.log("[ChangePassword] Form Submission Started", { 
            hasOld: !!formData.oldPassword, 
            hasNew: !!formData.newPassword, 
            hasConfirm: !!formData.confirmPassword 
        });

        try {
            const userIdString = getUserId();
            const userId = parseInt(userIdString);
            console.log("[ChangePassword] Retreived UserId:", userId);

            if (isNaN(userId)) {
                console.error("[ChangePassword] Error: UserId is NaN");
                toast.error("User session expired. Please log out and back in.");
                return;
            }

            console.log("[ChangePassword] Sending Request to Backend...");
            const response = await API.post("/auth/change-password", {
                userId: userId,
                oldPassword: formData.oldPassword,
                newPassword: formData.newPassword
            });

            console.log("[ChangePassword] Backend Response Received:", response);

            if (response.status === 200) {
                console.log("[ChangePassword] Success: Password changed successfully");
                toast.success("Password changed successfully!");
                navigate("/dashboard");
            } else {
                console.warn("[ChangePassword] Failed: Status Code", response.status, response.data);
                toast.error(response.data.message || "Failed to change password");
            }
        } catch (error) {
            console.error("[ChangePassword] Exception Occurred:", error);
            if (error.response) {
                console.error("[ChangePassword] Server Error Data:", error.response.data);
                console.error("[ChangePassword] Server Error Status:", error.response.status);
            }
            toast.error(error.response?.data?.message || "Something went wrong. Please try again.");
        } finally {
            setLoading(false);
            console.log("[ChangePassword] Form Submission Process Ended");
        }
    };

    return (
        <div className="admin-page-container">
            <div className="admin-header">
                <h1 className="admin-title">Change Password</h1>
                <p className="admin-subtitle">Update your account security</p>
            </div>

            <div className="admin-card" style={{ maxWidth: "500px" }}>
                <form onSubmit={handleSubmit} className="admin-form">
                    <div className="form-group">
                        <label className="form-label">Current Password</label>
                        <input
                            type="password"
                            name="oldPassword"
                            className="form-control"
                            value={formData.oldPassword}
                            onChange={handleChange}
                            required
                            placeholder="Enter current password"
                        />
                    </div>

                    <div className="form-group">
                        <label className="form-label">New Password</label>
                        <input
                            type="password"
                            name="newPassword"
                            className="form-control"
                            value={formData.newPassword}
                            onChange={handleChange}
                            required
                            placeholder="Enter new password"
                        />
                    </div>

                    <div className="form-group">
                        <label className="form-label">Confirm New Password</label>
                        <input
                            type="password"
                            name="confirmPassword"
                            className="form-control"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            required
                            placeholder="Confirm new password"
                        />
                    </div>

                    <div className="form-actions" style={{ marginTop: "24px" }}>
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={loading}
                        >
                            {loading ? "Updating..." : "Change Password"}
                        </button>
                        <button
                            type="button"
                            className="btn btn-outline"
                            onClick={() => navigate("/dashboard")}
                            disabled={loading}
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ChangePassword;
